module.exports = __webpack_public_path__ + "media/site_templates/www.airconditionerrepair.net.au/images/about_us-455cf10361d9be2dcd6f00f15a60bcfd.jpg";